import type { Dictionary } from './types';

export const ja: Dictionary = {
  page_title: 'AI-DLC フレームワーク',
  page_subtitle: 'NxKMS — AgentSkills Hub — プロジェクト展開のフロー',

  la_badge: 'レイヤー A',
  la_sub: 'エンタープライズ知識管理システム — すべての知識ソースを Knowledge Node に標準化',
  la_src_label: '知識入力ソース',
  la_s1_t: 'ファイルアップロード', la_s1_d: 'プロジェクトの Docs/PDF/MD',
  la_s2_t: 'Google Drive', la_s2_d: 'フォルダ別自動同期',
  la_s3_t: 'Notion / Slack', la_s3_d: '社内文書・議論',
  la_s4_t: 'Repo / Wiki', la_s4_d: 'CLAUDE.md, AGENTS.md',
  la_flow_label: '内部処理フロー — チームのインタラクション',
  la_f1: 'アップロード & 取り込み', la_f2: 'Knowledge Node へ標準化',
  la_f3: 'セマンティックインデックス', la_f4: 'ドメインタグ付け',
  la_f5: 'セマンティック検索', la_f6: 'プロジェクトアドバイザー → Skills 提案',
  la_f7: 'AgentSkills Hub へリンク',
  la_m1_t: 'Knowledge Repository',
  la_m1_d: 'ファイル・Drive のコンテンツを集約し、ドメイン別 Knowledge Node に標準化',
  la_m2_t: 'Project Advisor',
  la_m2_d: 'キックオフ時に tech stack/ドメインに応じた Skills を提案',
  la_uflow_label: 'ユーザーフロー — 管理者が設定、プロジェクトメンバーがチャット',
  la_uflow_admin_t: '管理者側',
  la_uflow_user_t: 'プロジェクトメンバー側',
  la_uflow_admin_steps: [
    '知識ソースのアップロード',
    'プロジェクト / ドメインでタグ付け',
    'チャットボット作成 (汎用または知識特化)',
    '社内公開',
  ],
  la_uflow_user_steps: [
    'NxKMS ポータルを開く',
    'プロジェクトチャットボットを選択',
    '自然言語で質問',
    '出典付き回答を受け取る',
  ],
  la_ui_demo_label: 'プレビュー — プロジェクトチャットボット UI',
  la_ui_sidebar_t: 'プロジェクトチャットボット',
  la_ui_bots: [
    { name: 'Fintech Payment Bot', desc: 'PCI-DSS ドメインエキスパート', active: true },
    { name: 'Legacy Migration Bot', desc: 'COBOL → Java コンテキスト' },
    { name: 'NTQ 汎用アシスタント', desc: '全社 Q&A' },
    { name: 'Monitoring / SRE Bot', desc: 'onTune, Beyla, Prometheus' },
  ],
  la_ui_user_msg: '日本顧客向けの 3DS チャレンジ失敗は決済フローでどう処理されていますか？',
  la_ui_bot_msg: 'PRD-023-payment.md および SBPayment 統合仕様によると、3DS 失敗は再試行キュー経由で 2 回までリトライされます。日本顧客は Fintech コンプライアンスルールに従い fraud-review フラグも発火します。',
  la_ui_sources_t: 'ソース',
  la_ui_sources: ['PRD-023-payment.md', 'sbpayment-integration.md', 'fintech-rules.md'],
  la_ui_input_ph: 'このプロジェクトについて質問...',

  conn_ab_dn: 'プロジェクトコンテキストに応じた Skills 提案',
  conn_ab_up: '検証済み Skills → Knowledge Base を展領',
  conn_ab_dn_note: 'NxKMS がプロジェクトドメインを分析し、最適な Skills を自動提案 — プロジェクトキックオフ時にトリガー。',
  conn_ab_up_note: 'レビュー・公開された Skills はドメインタグ付きで NxKMS に追加 — 次回以降のプロジェクトの検索精度向上。',

  lb_badge: 'レイヤー B',
  lb_sub: 'AI Skills の集約・管理・配信プラットフォーム — NTQ 全プロジェクト対応',
  lb_official_t: 'Official Skills — メーカー標準',
  lb_official_d: '技術を構築する企業・組織から提供 — NTQチームによる検証・同期済み',
  lb_see_more: '40以上のクリエーターを表示',
  lb_see_less: '非表示',
  lb_ntq_t: 'NTQ カスタマイズド Skills',
  lb_ntq_d: 'Tech stack/ドメイン/ロール別 — NTQ Cloud チームが構築・メンテ',
  lb_pkg_t: '特化プロジェクト向け Skills パッケージ',
  pkg1_t: 'Fintech Package', pkg2_t: 'レガシー移行', pkg3_t: 'Monitoring / SRE', pkg4_t: 'ISO 27001 / SOC2',
  lb_gov_label: 'ガバナンス & 品質管理',
  lb_gov_steps: ['Skill Author が作成', 'レビュワーが確認', 'Approve & バージョン', 'ハブに公開', 'Usage analytics'],
  lb_flow_label: 'Hub 内のチームインタラクションフロー',
  lb_f1: 'ドメイン/ロールで Skill 検索', lb_f2: 'CLI 経由でインストール', lb_f3: 'CLAUDE.md を更新',
  lb_f4: 'Admin: ポリシー管理', lb_f5: '導入率トラッキング', lb_f6: 'プロジェクトから新規 Skill 提案',
  lb_persona_label: 'ペルソナ',
  lb_p1: 'Skill Author — BA / Architect / シニア Dev',
  lb_p2: 'Skill Consumer — Dev / QA / PM',
  lb_p3: 'Reviewer / Team Lead',
  lb_p4: 'Enterprise Admin',
  lb_uflow_label: 'ユーザーフロー — 参照から IDE インストールまで',
  lb_uflow_steps: [
    '技術 / ドメイン / ロールで検索',
    'スキル詳細プレビュー',
    'CLI (skills.sh) でインストール',
    '.claude/skills を repo にコミット',
    'チーム全員が pull & 利用',
  ],
  lb_ui_demo_label: 'プレビュー — スキルマーケットプレイス',
  lb_ui_search_ph: 'スキルを検索...',
  lb_ui_filter_label: 'フィルター',
  lb_ui_filter_chips: ['Fintech', 'Java Spring', 'Vue / React', 'セキュリティ', 'Monitoring'],
  lb_ui_cards: [
    { name: 'fintech-payment', tag: 'NTQ · Domain', desc: '監査ログパターン付き PCI-DSS 対応決済ハンドラー', downloads: '1.2k インストール' },
    { name: 'spring-boot-3', tag: 'Official · Java', desc: 'Spring Boot 3.x 規約: Security, JPA, エラーハンドラー', downloads: '3.4k インストール' },
    { name: 'pr-checklist', tag: 'NTQ · Review', desc: 'マージ前セルフレビューチェックリスト + アーキテクチャ臭検出', downloads: '5.8k インストール' },
    { name: 'playwright-e2e', tag: 'Official · Testing', desc: 'Fixtures & リトライロジック付き Playwright テスト生成', downloads: '2.7k インストール' },
  ],
  lb_ui_install_t: 'インストール',
  lb_ui_install_hint: 'このコマンドをコピーしてプロジェクトへインストール',

  conn_bc_dn: 'プロジェクトの agent/IDE へ Skills をインストール',
  conn_bc_up: '実際のプロジェクトから導き出した Skills を貢献',
  conn_bc_dn_note: 'Tech Lead が Hub から Skills を選択し .claude/skills/ にインストール — git clone で全員共有。',
  conn_bc_up_note: 'Dev/BA がプロジェクト中に新たなベストプラクティスを発見 — Skill としてパッケージ化 — Hub へ提出して全体で再利用。',

  lc_badge: 'レイヤー C',
  lc_title: 'Project Deployment — AI-DLC In Practice',
  lc_sub: 'AI-DLC フレームワークに従った実プロジェクト進行 — 各プロジェクトが改善ループ',
  lc_steps_label: '10 展開ステップ — ステップをクリックして deck 内容を表示',
  lc_steps: ['Knowledge Foundation', 'Project Structure', 'IDE Mapping', 'Bootstrap', 'Daily Dev Loop', 'Testing', 'Team Standards', 'Security', 'I/O Map', 'Continuous Improvement'],
  lc_steps_th: ['ステップ', '名前', '担当', 'AI の役割', '成果物'],
  lc_steps_data: [
    ['S1', 'Knowledge Foundation', 'Tech Lead / BA', 'ドキュメントを Markdown に標準化; CLAUDE.md/AGENTS.md 草稿作成; docs/context を構築し AI 出力品質 = 知識品質を実現', 'CLAUDE.md, AGENTS.md, docs/ フォルダ'],
    ['S2', 'Project Structure', 'Tech Lead', '.claude/ ツリー (rules, skills, commands)、docs/ 構造、命名規則、共有 skills/workflows レジストリを定義', '.claude/, docs/requirements, docs/architecture committed'],
    ['S3', 'IDE Mapping', 'Dev Team', 'Claude Code · Cursor · Windsurf で同じ概念をマッピング (rules, commands, hooks, MCP); チームで IDE を統一', 'settings.json, .cursor/rules/, .windsurfrules'],
    ['S4', 'Bootstrap', 'Tech Lead + AI', 'AI が /init でコードベースをスキャン → CLAUDE.md/AGENTS.md 草稿; ベース Skills のインストール & カスタマイズ; /feature /fix /review commands 定義', 'CLAUDE.md v1, .claude/skills, .claude/commands'],
    ['S5', 'Daily Dev Loop', 'PM/BA · Dev · AI · CI', 'チケット → /onboard → task file → /feature (plan + TDD + hooks) → 自己レビュー → human diff review → CI → PR ready; specs/coding/質問/review/debug/planning のサブフロー', 'Task file log, code + tests, PR ready'],
    ['S6', 'Testing', 'QA / Dev', '3 フロー: Unit Test (/test)、E2E Playwright (/e2e)、Requirement-first (/test-plan — PRD acceptance criteria から)', 'Test plan, .test.ts, .spec.ts, coverage report'],
    ['S7', 'Team Standards', 'Tech Lead / Reviewer', '4 層: Source of truth · Gold-standard examples · Hooks+CI enforcement · Skill/Docs PR process — "3人3スタイル" を排除', 'team-ai-standards/, gold-standard/, Output Consistency Checklist'],
    ['S8', 'Security', 'Security Lead / Dev', '6 防御層 (アーキテクチャ · git · settings.json permissions · hooks · CI · rules); rules/security.md で process.env 強制 + sk-/api_key/password 自己スキャン', '.gitignore, deny rules, gitleaks CI, security-hook.sh'],
    ['S9', 'I/O Map', 'BA / Tech Lead', '各フェーズの Human Input · AI 作業 · Human Gate · Output の表 (Knowledge Foundation → Bootstrap → Intake → Design → Implement → Test → Deploy → Improve)', 'I/O diagram (Markdown), API contract'],
    ['S10', 'Continuous Improvement', '全ロール', '定期スケジュールなし — イベント駆動: AI が同じミスを繰り返す、同じ context を説明、より良いパターン発見、新ツール、インシデント — skill/rule を即時更新', '更新済み CLAUDE.md, Hub に新 skills, NxKMS に docs'],
  ],
  lc_flow_label: 'プロジェクト内チームインタラクションフロー',
  lc_f1: 'Hub から Skill を検索', lc_f2: 'IDE 設定 & インストール', lc_f3: 'AI agent が実行', lc_f4: 'Dev / QA レビュー',
  lc_f5: 'NxKMS を参照', lc_f6: 'Skill を改善 & イテレーション', lc_f7: 'Skill を Hub へ貢献',
  lc_m1_t: '運用中',
  lc_m1_d: '新たなパターン発見 — Skill 草稿 — Hub へレビュー申請',
  lc_m2_t: 'プロジェクト完了後',
  lc_m2_d: 'レトロスペクティブ — 教訓をまとめ — Skill / Knowledge Node としてパッケージ化',
  lc_contrib: '全ロール (Dev, BA, QA, PM) が AgentSkills Hub へ Skills を、NxKMS へ文書を貢献できる — NTQ 全体の改善ループを形成',

  leg_a: 'NxKMS (知識)', leg_b: 'AgentSkills Hub (Skills)', leg_c: 'Project Layer (実行)', leg_flow: '下流フロー',

  ntq_cat_tech: '技術スタック別',
  ntq_cat_domain: 'プロジェクトドメイン別',
  ntq_cat_role: 'ロール別',
  ntq_tags_tech: [
    { t: 'AWS / Azure', s: 'IaC, Lambda, AKS' },
    { t: 'Java Spring', s: 'Boot 3.x, Security' },
    { t: 'Vue / React', s: 'Vue 3, Next.js 14' },
    { t: 'Go backend', s: 'Gin, gRPC, Ent' },
    { t: 'C# .NET', s: 'Core 8, EF' },
    { t: 'Node.js', s: 'Express, Fastify' },
    { t: 'Python', s: 'FastAPI, Django' },
    { t: 'Mobile', s: 'Flutter, Expo' },
  ],
  ntq_tags_domain: [
    { t: 'Fintech', s: 'PCI-DSS, 決済' },
    { t: 'Healthcare', s: 'HIPAA, EHR' },
    { t: 'E-commerce', s: 'Shopify, Cart' },
    { t: 'レガシー移行', s: 'COBOL → Java' },
    { t: 'Monitoring / SRE', s: 'onTune, Beyla' },
    { t: 'Edtech', s: 'LMS, KT' },
    { t: 'JP 企業', s: 'SBPayment, Bajie' },
    { t: 'KR 企業', s: 'onTune, WhaTap' },
  ],
  ntq_tags_role: [
    { t: 'BA', s: '要件・仕様' },
    { t: 'PM / PO', s: 'ロードマップ' },
    { t: 'Dev', s: 'コード・レビュー' },
    { t: 'QA', s: 'Playwright, テスト計画' },
    { t: 'DevOps', s: 'CI/CD, IaC' },
    { t: 'Security Lead', s: 'OWASP, 監査' },
    { t: 'Tech Lead', s: '構造・Skill' },
    { t: 'Designer', s: 'Figma, hand-off' },
  ],

  access_title: 'プロジェクトチームのアクセス方法',
  access_desc: 'メンバーは <span class="access-pill access-pill-a">NxKMS</span> で知識を検索し Skills の提案を受けるか、あるいは <span class="access-pill access-pill-b">AgentSkills Hub</span> で直接 Skills を検索・インストール・管理 — 両ルートとも同一のエコシステムに統合される。',
  access_or: 'または',
  access_path_a_label: 'NxKMS',
  access_path_a_desc: 'エンタープライズ知識を検索し、プロジェクトに最適な Skills の提案を受ける',
  access_path_a_badge: 'ナレッジパス',
  access_path_b_label: 'AgentSkills Hub',
  access_path_b_desc: 'IDE & プロジェクト向けに AI Skills を直接検索・インストール・管理',
  access_path_b_badge: 'スキルパス',
  access_note: '両ルートとも同一のエコシステムに統合されます。',

  footer_copy: '© 2026 NTQ Solution JSC — AI-DLC Framework. All rights reserved.',
  footer_version: 'v1.0',

  step_panel_prev: '‹ 前のステップ',
  step_panel_next: '次のステップ ›',
  step_panel_close: '閉じる ✕',
  step_panel_open_hint: '上のステップをクリックして deck の内容を表示',

  deck: {
    s0_title: 'AI-DLC In Practice',
    s0_sub: 'プロジェクトで実際にどう動くか — ステップバイステップ',
    s0_msg: '"AI-DLC はコードから始まりません。知識をドキュメントに標準化することから始まります。それ以外のすべてはその基盤に依存しています。"',

    s1_title: 'Knowledge Foundation',
    s1_sub: '最も重要なステップ — よく省略される',
    s1_msg: 'AI 出力品質 = 提供される知識の品質',
    s1_col1_t: '生の知識',
    s1_col2_t: '標準化 →',
    s1_col3_t: 'AI 対応インプット',
    s1_col1: [
      'ドキュメントのないコードベース',
      'Wiki、メール、会議メモ',
      '人の頭の中にある技術的決定',
      'PM しか知らないビジネスルール',
    ],
    s1_col2: [
      '全コンテンツ → Markdown (.md)',
      '明確なヘッダー階層 H1→H2→H3',
      'Mermaid で図示 (バージョン管理可)',
      '意味のある名前: PRD-001-auth.md',
    ],
    s1_col3: [
      'CLAUDE.md / AGENTS.md < 200 行',
      'rules/ を関心事ごとに分割',
      'skills/ — オンデマンドモジュール',
      'docs/context/ — AI 専用コンテキスト',
    ],

    s1b_title: 'Knowledge Foundation: ツール',
    s1b_sub: '知識抽出を高速かつ確実にする推奨ツール',
    s1b_groups: [
      {
        title: 'Knowledge Graph — コード可視化・インタラクティブ探索',
        color: '#4F46E5',
        tools: [
          {
            name: 'GitNexus',
            tag: 'Zero-server · ブラウザネイティブ Knowledge Graph  ⚠ カスタムパーサー要',
            desc: 'GitHub リポジトリや ZIP をドロップするだけで、ブラウザ内でインタラクティブな knowledge graph を構築。Graph RAG エージェントによるコード Q&A 内蔵。非対応言語 (COBOL、Delphi、カスタム DSL) は事前に custom tree-sitter パーサーの作成が必要。',
            usage: '新規プロジェクト開始前に使用。未対応言語・ライブラリはカスタムパーサーを作成すること。',
            url: 'github.com/abhigyanpatwari/GitNexus',
            color: '#4F46E5',
          },
          {
            name: 'Understand-Anything',
            tag: 'Claude Code Skill · インタラクティブ Codebase Knowledge Graph',
            desc: 'どのコードベースもインタラクティブな knowledge graph に変換する Claude Code / Codex スキル。マルチプラットフォーム対応。コード関係性やコールチェーンの検索・探索・質問が可能。',
            usage: 'Claude Code で /understand-anything コマンドを使いリアルタイムにコードベースを探索。',
            url: 'github.com/Lum1104/Understand-Anything',
            color: '#0B8A75',
          },
          {
            name: 'Repomix',
            tag: 'CLI · リポジトリ全体を AI 可読単一ファイルに梱包',
            desc: 'コードベース全体を LLM コンテキストウィンドウに最適化した単一 Markdown/XML ファイルに梱包。.repomixignore、セキュリティフィルター、トークンカウントに対応。プロジェクト全体のコンテキストを一度に AI へ送信するのに最適。',
            usage: 'コードベース全体を把握する必要がある AI セッション前に実行。生成ファイルは .repomixignore で除外。',
            url: 'github.com/yamadashy/repomix',
            color: '#E6522C',
          },
          {
            name: 'code2prompt',
            tag: 'CLI · ソース → フルコンテキスト付き構造化プロンプト',
            desc: 'ソースコードファイルをシンタックスハイライト・ツリービュー・ファイルメタデータ付きの構造化プロンプトに変換。glob パターンでファイル選択可能。AI チャットへのコピーペーストや CLAUDE.md への注入に最適化された出力。',
            usage: '特定モジュールから焦点を絞ったプロンプトを生成する際に使用。/feature と組み合わせて AI に正確なコンテキストを提供。',
            url: 'github.com/mufeedvh/code2prompt',
            color: '#F59E0B',
          },
        ],
      },
      {
        title: 'フォーマット変換 — 各種ドキュメントを AI 可読 Markdown に変換',
        color: '#0078D4',
        tools: [
          {
            name: 'MarkItDown (カスタマイズ版)',
            tag: 'Microsoft · PDF / DOCX / PPTX / Web → Markdown  ⚠ プロジェクトごとにカスタマイズ必須',
            desc: 'プロジェクトごとにカスタマイズが必要 — 各プロジェクトでフォーマット・セクション構造・命名規則が異なる。日本語プロジェクトはエンコーディング処理 (Shift-JIS/UTF-8)、ふりがな除去、見出し再マッピングが必要。アダプターなしでは Markdown 出力が AI を誤誘導する。',
            usage: 'プロジェクトアダプター (convert_docs.py) を作成。代表的なサンプル 3〜5 件でテスト後に使用。',
            url: 'github.com/microsoft/markitdown',
            color: '#0078D4',
          },
          {
            name: 'Docling',
            tag: 'IBM · PDF / DOCX / HTML → 構造化 Markdown + JSON',
            desc: 'ネイティブのテーブル抽出・図検出・ドキュメント構造保持を備えた IBM オープンソースパーサー。Markdown・JSON・Docling Document 形式にエクスポート。内蔵 OCR でスキャン PDF にも対応。複雑なレイアウトでは MarkItDown より構造忠実度が高い。',
            usage: '複雑なテーブルや図を含む PDF (契約書、仕様書、レポート) に使用。RAG 取り込みのためのチャンキングパイプラインと組み合わせる。',
            url: 'github.com/DS4SD/docling',
            color: '#0062A3',
          },
          {
            name: 'Marker',
            tag: 'GPU加速 · PDF → 高品質 Markdown  ⚠ 速度には GPU 推奨',
            desc: 'レイアウト検出と OCR モデルを使用した最先端の PDF → Markdown コンバーター。段組み・脚注・数式・コードブロックに対応。学術論文や複雑な日本語・韓国語文書で最高品質。バッチ処理には GPU 推奨。',
            usage: 'MarkItDown で構造が失われる スキャン PDF や複雑なドキュメントに使用。バッチ変換は GPU 環境でローカル実行。',
            url: 'github.com/VikParuchuri/marker',
            color: '#7C3AED',
          },
          {
            name: 'PyMuPDF4LLM',
            tag: 'PyMuPDF · ページ対応チャンキングによる高速 PDF → Markdown',
            desc: 'LLM 最適化出力による高速・高精度 PDF 抽出のために PyMuPDF 上に構築された Python ライブラリ。ページ単位抽出・ヘッダー検出・ハイパーリンク保持に対応。複雑なレイアウトのない文字多めの PDF では Marker より大幅に高速。',
            usage: 'テキスト中心ドキュメントのデフォルト PDF 抽出ツールとして使用。レイアウト忠実度が重要な場合のみ Marker に切り替え。',
            url: 'github.com/pymupdf/PyMuPDF',
            color: '#059669',
          },
        ],
      },
    ],
    s1b_flow: ['ソース (PDF/DOCX/Repo/URL)', 'プロジェクト別アダプターカスタマイズ', '抽出・変換', '構造化・インデックス化', 'docs/context/ にコミット'],
    s1b_note: '⚠ すべてのツールはプロジェクトごとにカスタマイズが必要。フォーマット変換ツールはエンコーディング/レイアウトアダプターが必要 (特に日本語)。Knowledge graph ツールは非対応言語向けカスタムパーサーが必要。出力をコミットする前に必ず実サンプル 3〜5 件でテストすること。',

    s2_title: 'Project Structure',
    s2_sub: '.claude/ + docs/ — すべてのファイルに場所と目的がある',
    s2_legend: [
      { type: 'always', label: '常時ロード' },
      { type: 'ondemand', label: 'オンデマンド' },
      { type: 'manual', label: '手動トリガー' },
      { type: 'hooks', label: '自動 hooks' },
      { type: 'ide', label: 'IDE 固有' },
    ],
    s2_tree: [
      { txt: 'project-root/', type: 'root' },
      { txt: '├── CLAUDE.md', type: 'always', note: 'チーム共有エントリーポイント — プロジェクト規約、スタック、必須事項 (< 200 行)' },
      { txt: '├── AGENTS.md', type: 'always', note: 'Cursor/Windsurf 対応のクロス IDE バリアント' },
      { txt: '├── CLAUDE.local.md', type: 'muted', note: '個人オーバーライド (gitignore 済み)' },
      { txt: '├── .claude/', type: 'root' },
      { txt: '│   ├── rules/', type: 'always', note: '常時有効なルール — 関心事ごとに分割 (security, style, api)' },
      { txt: '│   ├── skills/', type: 'ondemand', note: 'オンデマンド skills (api-handler, unit-test, ...)' },
      { txt: '│   ├── commands/', type: 'manual', note: '/feature /fix /review /deploy — スラッシュコマンド' },
      { txt: '│   ├── agents/', type: 'ondemand', note: '専門フロー用 Sub-agents' },
      { txt: '│   └── settings.json', type: 'hooks', note: 'Hooks (Pre/PostToolUse)、権限、deny rules' },
      { txt: '├── .cursor/rules/', type: 'ide', note: 'Cursor 版 rules の相当物 (*.mdc)' },
      { txt: '├── .windsurfrules', type: 'ide', note: 'Windsurf グローバルルール' },
      { txt: '├── .mcp.json', type: 'ondemand', note: 'MCP サーバー設定' },
      { txt: '├── docs/', type: 'root', note: '詳細は次のスライドを参照' },
      { txt: '└── src/ · tests/ · ...', type: 'muted', note: '標準プロジェクトコード' },
    ],

    s2b_title: 'docs/ フォルダ構造',
    s2b_sub: '詳細 — 各サブフォルダを命名規則とともに説明',
    s2b_tree: [
      { txt: 'docs/', type: 'root' },
      { txt: '├── requirements/', type: 'always', note: 'PRD ファイル — feature または epic ごとに 1 つ' },
      { txt: '│   ├── PRD-001-user-auth.md', type: 'always', note: '問題 + 目標 + AC + スコープ外' },
      { txt: '│   └── PRD-002-payments.md', type: 'always', note: '命名: PRD-[番号]-[短い名前].md' },
      { txt: '├── architecture/', type: 'root' },
      { txt: '│   ├── decisions/', type: 'always', note: 'ADRs — 承認後は不変' },
      { txt: '│   │   ├── ADR-001-auth-strategy.md', type: 'always', note: '背景 + 決定 + 代替案 + 影響' },
      { txt: '│   │   └── ADR-002-database.md', type: 'always', note: '命名: ADR-[番号]-[トピック].md' },
      { txt: '│   ├── api-contracts/', type: 'ondemand', note: 'ドメイン別 API スキーマ' },
      { txt: '│   │   └── auth.md', type: 'ondemand', note: 'API エンドポイント変更時に更新' },
      { txt: '│   └── system-overview.md', type: 'always', note: 'Mermaid 図付きの高レベルアーキテクチャ' },
      { txt: '├── tasks/', type: 'root' },
      { txt: '│   ├── active/', type: 'manual', note: '現在のスプリント — AI がここにセッションログを記録' },
      { txt: '│   │   └── TASK-101.md', type: 'manual', note: '目標 + AC + コンテキスト + テストシナリオ' },
      { txt: '│   └── done/', type: 'muted', note: '完了 — マージ後に移動' },
      { txt: '├── context/', type: 'ondemand', note: 'AI 専用の長期知識' },
      { txt: '│   ├── domain-glossary.md', type: 'ondemand', note: 'ビジネス用語 — AI のハルシネーション防止' },
      { txt: '│   ├── known-issues.md', type: 'ondemand', note: '現在のバグと回避策' },
      { txt: '│   ├── business-rules.md', type: 'ondemand', note: 'PM/BA しか知らないルール' },
      { txt: '│   └── tool-changelog.md', type: 'ondemand', note: 'チームが新しいアプローチを採用した時' },
      { txt: '└── templates/', type: 'manual', note: '新規ファイル用のコピペスターター' },
    ],

    s2c_title: '必須 Skills & Workflows',
    s2c_sub: 'Sprint 1 前に定義 — チームの AI オペレーティングシステム',
    s2c_skills_t: 'Skill カテゴリ (AI が専門化できる内容)',
    s2c_workflows_t: 'コアスラッシュコマンド (毎日使用)',
    s2c_skills: [
      { cat: '基盤 (最初にインストール)', items: ['find-skills', 'skill-creator', 'context-builder'], color: 'teal' },
      { cat: 'Coding', items: ['api-handler', 'component', 'service', 'database'], color: 'accent' },
      { cat: 'Testing', items: ['unit-test', 'e2e-playwright', 'test-plan'], color: 'teal' },
      { cat: 'Review', items: ['pr-checklist', 'code-review'], color: 'amber' },
      { cat: 'Infrastructure', items: ['security', 'docker', 'ci-cd'], color: 'purple' },
    ],
    s2c_workflows: [
      { cmd: '/find-skills [トピック]', desc: 'スキルの検索と発見' },
      { cmd: '/create-skill [名前]', desc: 'テンプレートから新規スキルを作成' },
      { cmd: '/feature TASK-xxx', desc: '完全な TDD 実装フロー' },
      { cmd: '/fix TASK-xxx', desc: 'リグレッションテスト付きバグ修正' },
      { cmd: '/review', desc: 'PR 自己レビューチェックリスト' },
      { cmd: '/deploy [env]', desc: 'プリフライトゲート付きデプロイ' },
      { cmd: '/test [file]', desc: 'ユニットテスト生成' },
      { cmd: '/test-plan PRD-xxx', desc: 'スペックファーストのテスト計画' },
      { cmd: '/onboard TASK-xxx', desc: 'チケットからタスク取り込み' },
      { cmd: '/e2e [scenario]', desc: 'E2E Playwright テスト' },
      { cmd: '/init', desc: 'プロジェクトブートストラップスキャン' },
      { cmd: '/refactor [scope]', desc: '安全なリファクタリングワークフロー' },
    ],

    s3_title: 'IDE Tool Mapping',
    s3_sub: 'Claude Code · Cursor · Windsurf — 同じ概念、異なる構文',
    s3_th: ['概念', 'Claude Code', 'Cursor', 'Windsurf'],
    s3_rows: [
      ['Always-on Rules', 'CLAUDE.md\n+ .claude/rules/*.md', '.cursor/rules/*.mdc\n(alwaysApply: true)', '.windsurfrules\nglobal_rules.md'],
      ['Path-scoped Rules', 'サブディレクトリ\nCLAUDE.md', '*.mdc with\nglob patterns', 'Workspace rules\n(glob mode)'],
      ['On-demand Skills', 'skills/\n(自動起動)', 'rules/ with\n@ruleName manual', 'Memories\n(自動保存/呼出)'],
      ['Slash Commands', 'commands/*.md', 'rules/ description\nfield', 'Workflows\n/workflow-name'],
      ['Auto Events', 'settings.json\nPre/PostToolUse', 'SKILL.md\nhooks', 'Auto-memory +\nTurbo mode'],
      ['Sub-agents', 'agents/*.md', 'Background\nAgents', 'Parallel\nCascades'],
      ['Cross-IDE', 'AGENTS.md (root)', 'AGENTS.md (root)', 'AGENTS.md (root)'],
      ['MCP', '.mcp.json', '.mcp.json', '.mcp.json'],
    ],

    s4_title: 'Project Bootstrap',
    s4_sub: '一度だけの設定 — Sprint 1 前に完了',
    s4_lanes: ['Tech Lead', 'Dev Team', 'AI Agent', 'Output'],
    s4_steps: [
      { row: 0, lane: 0, text: 'tech stack を定義\nbusiness domain\nコーディング規約', type: 'io' },
      { row: 0, lane: 2, text: '/init → コードベーススキャン\nフレームワーク・パターン\n依存関係・テスト設定を検出', type: 'step' },
      { row: 1, lane: 3, text: 'CLAUDE.md ドラフト\nAGENTS.md ドラフト', type: 'io' },
      { row: 1, lane: 0, text: 'ドラフトをレビュー\nビジネスコンテキスト追加\nNEVER-do ルール追加\n< 200 行に抑える', type: 'gate' },
      { row: 2, lane: 3, text: 'CLAUDE.md v1 ✓\nAGENTS.md v1 ✓', type: 'note' },
      { row: 2, lane: 0, text: 'skills.sh + 公式リポジトリから\nベース skills を検索 & インストール\n→ プロジェクト向けにカスタマイズ', type: 'step' },
      { row: 2, lane: 2, text: 'skills をカスタマイズ:\n+ プロジェクトパターン\n+ Gotchas セクション\n+ examples/ フォルダ', type: 'step' },
      { row: 3, lane: 3, text: '.claude/skills/ ✓\n.cursor/rules/ ✓', type: 'note' },
      { row: 3, lane: 0, text: 'コマンドを定義:\n/feature /fix\n/review /deploy', type: 'step' },
      { row: 3, lane: 2, text: 'コマンドファイルを作成\nsettings.json で\nhooks を設定', type: 'step' },
      { row: 4, lane: 3, text: '.claude/commands/ ✓\nsettings.json ✓', type: 'note' },
      { row: 4, lane: 0, text: '.claude/ を git にコミット\n全員がクローン → 準備完了', type: 'gate' },
      { row: 5, lane: 3, text: 'チーム全員準備完了 ✓', type: 'note' },
    ],

    s5_title: 'Daily Dev Loop',
    s5_sub: 'フィーチャー開発スイムレーン — 毎日繰り返す',
    s5_lanes: ['PM / BA', 'Dev', 'AI Agent', 'CI / CD', 'Output'],
    s5_steps: [
      { row: 0, lane: 0, text: 'チケット #101 を作成\n(acceptance criteria 付き)', type: 'io' },
      { row: 0, lane: 1, text: '/onboard TASK-101', type: 'step' },
      { row: 0, lane: 2, text: 'MCP でチケット読み込み\n関連ファイルをスキャン\n曖昧点を特定', type: 'step' },
      { row: 1, lane: 2, text: '確認質問をする', type: 'step' },
      { row: 1, lane: 0, text: '質問に回答\nスコープを確認', type: 'gate' },
      { row: 1, lane: 3, text: 'CI ウォームアップ', type: 'note' },
      { row: 2, lane: 2, text: 'TASK-101.md を作成:\n• 目標 + AC\n• 技術メモ\n• テストシナリオ', type: 'step' },
      { row: 2, lane: 1, text: 'task file をレビュー ✓\n/feature TASK-101', type: 'gate' },
      { row: 2, lane: 2, text: 'rules + skills をロード\n→ PLAN MODE:\nアプローチを提案', type: 'step' },
      { row: 3, lane: 1, text: 'プランを承認\nまたは修正', type: 'gate' },
      { row: 3, lane: 2, text: '[HOOK: PreToolUse]\n→ 失敗テスト作成\n→ 実装\n[HOOK: PostToolUse]', type: 'hooks' },
      { row: 4, lane: 2, text: 'pr-checklist skill で\n自己レビュー\nTASK-101 ログ更新', type: 'step' },
      { row: 4, lane: 1, text: 'diff をレビュー\nAC を手動テスト\nPR をプッシュ', type: 'gate' },
      { row: 4, lane: 3, text: 'CI: unit tests\nlint · secret scan\ncoverage check', type: 'step' },
      { row: 4, lane: 4, text: 'Code ✓  Tests ✓\nPR ready ✓', type: 'io' },
    ],

    s5b_title: '効果的な毎日のプロンプト',
    s5b_sub: '最良の AI 出力を得るために指示に含めるべき内容',
    s5b_anat_t: '良いプロンプトの解剖',
    s5b_examples_t: '実例 (コピー & ペースト)',
    s5b_anat: [
      { t: 'コンテキスト', d: '何をしているか？関連するファイルは？' },
      { t: 'ターゲットアクション', d: 'AI に何をさせるか？(/feature, /refactor)' },
      { t: '制約', d: '何を避けるか？どのルールに従うか？' },
    ],
    s5b_examples: [
      { tag: 'フィーチャー実装', body: '/feature TASK-xxx\nPRD-001 に基づいて UserProfile コンポーネントを実装してください。スタイリングには Tailwind を使用。state を直接変更しないこと; docs/rules/ の React パフォーマンス標準に従ってください。' },
      { tag: 'リファクタリング', body: '/refactor\nこのファイルをリファクタリングして、データ取得ロジックをカスタム React hook (useUserProfile) に抽出してください。既存のテストを通過させたまま維持。UI 変更なし。' },
      { tag: 'デバッグ', body: '/fix\nトークン期限切れ時に API が 401 を返す。auth.ts と axios interceptors を確認。ADR-002-auth-strategy.md に基づいて自動トークンリフレッシュロジックを追加。' },
    ],

    s5c_title: 'Specs & Brainstorm Flow',
    s5c_sub: 'アイデアから確定した要件へ — AI を思考パートナーとして',
    s5c_lanes: ['BA / PM', 'AI Assistant', 'Human Gate'],
    s5c_steps: [
      { lane: 0, row: 0, text: '初期フィーチャーブリーフ\nまたはユーザーストーリーを作成', type: 'io' },
      { lane: 1, row: 0, text: 'ブリーフを解析 → 意図を明確化\n→ ユースケースを提案', type: 'step' },
      { lane: 2, row: 0, text: 'レビュワー: ドラフトを\n承認または却下', type: 'gate' },
      { lane: 0, row: 1, text: 'ドメインコンテキスト\n+ ターゲット + 制約を提供', type: 'step' },
      { lane: 1, row: 1, text: 'acceptance criteria\n+ edge cases + スコープ外を生成', type: 'step' },
      { lane: 2, row: 1, text: 'Tech Lead レビュー:\nAC 承認 → PRD-xxx.md を確定', type: 'gate' },
      { lane: 0, row: 2, text: 'PRD-xxx.md を\ndocs/requirements/ にコミット', type: 'io' },
      { lane: 1, row: 2, text: 'PRD から TASK-xxx.md を\n自動生成', type: 'step' },
      { lane: 2, row: 2, text: 'スプリント準備完了 ✓\nバックログ更新済み ✓', type: 'note' },
    ],
    s5c_tips: [
      'プロンプトに含める: 現在のドラフトテキスト · ターゲットオーディエンス · ビジネス制約 · AI が想定してはいけないこと',
      '例文opener: "これは支払いモジュールの PRD ドラフトです。ターゲット: B2B クライアント。制約: PCI-DSS 準拠必須。不足している要件と edge cases を特定してください。"',
      'AI が得意なこと: 曖昧な要件の発見 · ネガティブテストケースの提案 · ナラティブから AC の作成 · 相反する目標の検出',
    ],

    s5d_title: 'Coding Flow',
    s5d_sub: 'Task → Plan → Implement → Review — ガードレール付き AI ペアプログラミング',
    s5d_lanes: ['Human', 'Plan', 'Implement', 'Verify'],
    s5d_steps: [
      { lane: 0, row: 0, text: '/feature TASK-101\n(task file をロード\n+ 関連 skills)', type: 'step' },
      { lane: 1, row: 0, text: 'AI が rules/\n+ skills/ を読む → アプローチ提案', type: 'step' },
      { lane: 0, row: 1, text: 'プランをレビュー:\n承認 ✓ または修正 ✗', type: 'gate' },
      { lane: 2, row: 1, text: 'AI が先に失敗\nテストを書く (TDD)', type: 'step' },
      { lane: 2, row: 2, text: 'AI がテストを\nパスする実装を行う', type: 'step' },
      { lane: 3, row: 2, text: 'Hooks: 自動フォーマット\nlint チェック\n→ 失敗時はブロック', type: 'hooks' },
      { lane: 0, row: 3, text: 'Human が diff をレビュー\n+ AC を確認 → PR ready', type: 'gate' },
      { lane: 3, row: 3, text: 'CI: tests + scan\n→ パスなら merge', type: 'io' },
    ],
    s5d_tips: [
      '/feature prompt: "TASK-101 を実装。docs/rules/react-perf.md に従う。hooks を使用、class components 不可。スコープ外: payment logic。auth.ts に触れる前に止まって確認。"',
      '/fix prompt: "バグ: トークン期限切れ時に API が 401 を返す。症状: セッション中にログインページが出現。仮説: interceptor がリトライしていない。まず src/api/interceptors.ts を確認。"',
      '/refactor prompt: "UserProfile.tsx からデータ取得を useUserProfile hook に抽出。すべてのテストを通過させたまま維持。JSX レイアウトや props インターフェースは一切変更しないこと。"',
    ],

    s5e_title: 'Asking Flow',
    s5e_sub: 'コードベースを変更せずに理解する',
    s5e_lanes: ['Developer', 'AI Agent', 'Gate'],
    s5e_steps: [
      { lane: 0, row: 0, text: 'コンテキストファイルをロード:\n@file.ts @ADR-00x.md', type: 'io' },
      { lane: 1, row: 0, text: 'スコープを確認:\nファイルが明確化必要か確認', type: 'step' },
      { lane: 0, row: 1, text: "質問を提示:\n'X はどう動く？'\n'Y を変更すると何が壊れる？'", type: 'step' },
      { lane: 1, row: 1, text: 'コードフローをステップごとに追跡\n行番号を引用', type: 'step' },
      { lane: 2, row: 1, text: 'Dev が AI の回答を\n実際のコードと照合', type: 'gate' },
      { lane: 0, row: 2, text: '間違い: 修正 + 再質問\n正しい: 続行', type: 'step' },
      { lane: 1, row: 2, text: 'コードを生成しない\n— 回答のみ', type: 'note' },
    ],
    s5e_tips: [
      'すべての探索プロンプトに "コード変更を提案しないこと" を追加する',
      '常に @file 参照を使用 — AI が見ていないコードについてハルシネーションするのを防ぐ',
      '何を (WHAT) だけでなく、なぜ (WHY) を聞く。"トークンがクッキーではなくメモリに保存される理由を説明して"',
    ],

    s5f_title: 'Reviewing Flow',
    s5f_sub: 'ヒューマンレビュアー前の AI プレレビュー — 構造化アウトプット',
    s5f_lanes: ['Developer', 'AI Agent', 'Human Reviewer'],
    s5f_steps: [
      { lane: 0, row: 0, text: '変更をステージング:\ngit add -p (選択的)', type: 'io' },
      { lane: 0, row: 1, text: '実行: /review\n@docs/rules/code-style.md\n@docs/rules/security.md', type: 'step' },
      { lane: 1, row: 1, text: 'ステージング diff を分析\nrules + ADRs と照合', type: 'step' },
      { lane: 1, row: 2, text: 'アウトプット:\nBLOCKER (修正必須)\nWARNING (検討)\nSUGGESTION (任意)', type: 'step' },
      { lane: 0, row: 2, text: 'すべての BLOCKER を修正\nプッシュ + PR オープン', type: 'gate' },
      { lane: 2, row: 3, text: 'レビュー:\nビジネスロジック\n設計上の決定', type: 'gate' },
      { lane: 2, row: 3, text: 'Merge ✓ または変更要求', type: 'io' },
    ],
    s5f_tips: [
      'AI がチェック: ルール違反 · エラーハンドリング不足 · セキュリティ問題 · 命名/パターンの逸脱',
      'Human が注力: ビジネスロジックの正確性 · 設計上の決定 · 知識移転 · 新パターン',
      'レビュープロンプト: "ステージング diff をレビュー。出力: BLOCKER | WARNING | SUGGESTION。Prettier が処理するスタイル問題はフラグ不要。"',
    ],

    s5g_title: 'Debugging Flow',
    s5g_sub: '体系的なバグ調査 — 正確な診断のための構造化コンテキスト',
    s5g_lanes: ['Developer', 'AI Agent', 'Output'],
    s5g_steps: [
      { lane: 0, row: 0, text: 'バグを再現\n収集: エラー + スタックトレース', type: 'io' },
      { lane: 0, row: 1, text: 'ロード: TASK-xxx.md\n+ 疑わしいファイル + ADRs', type: 'step' },
      { lane: 0, row: 1, text: '仮説を述べる\n+ セーフゾーン (X に触れないこと)', type: 'step' },
      { lane: 1, row: 2, text: 'コールチェーンをトレース\n根本原因を特定\n修正オプションを提案', type: 'step' },
      { lane: 0, row: 2, text: '修正を受け入れる前に\n診断を検証', type: 'gate' },
      { lane: 1, row: 3, text: 'セーフゾーン境界内で\n修正を実装', type: 'step' },
      { lane: 2, row: 3, text: 'unit tests 実行 ✓\nリグレッションテスト追加 ✓', type: 'io' },
    ],
    s5g_tips: [
      'バグコンテキスト: 症状 + エラーメッセージ (完全なスタックトレース) + 再現手順',
      '仮説: 最善の推測 — 間違った仮説でも AI が絞り込みを速める',
      'セーフゾーン: "変更禁止: LoginPage, authSlice.ts" — AI の過剰介入を防ぐ',
    ],

    s5h_title: 'Planning Flow',
    s5h_sub: '作業を小さな検証可能なタスクに分解 — AI 実行のための明確な入出力',
    s5h_lanes: ['Tech Lead / Dev', 'AI Agent', 'Gate'],
    s5h_steps: [
      { lane: 0, row: 0, text: 'ロード: PRD-xxx.md\n+ アーキテクチャドキュメント\n+ 既存のタスク', type: 'io' },
      { lane: 0, row: 0, text: "目標を説明:\n'フィーチャー X を構築'\nまたは 'モジュール Y をリファクタ'", type: 'step' },
      { lane: 1, row: 1, text: 'サブタスクに分解\n各タスクに:\n- 入力ファイル\n- 出力ファイル\n- 検証チェックリスト', type: 'step' },
      { lane: 0, row: 1, text: 'タスクプランをレビュー:\n各タスクは十分に小さいか？\n(< 1 セッション)', type: 'gate' },
      { lane: 1, row: 2, text: '各サブタスクに対して:\n完全なテンプレートで\nTASK-xxx.md を生成', type: 'step' },
      { lane: 0, row: 2, text: '確認: 各タスクに\n明確な AC + 検証手順があるか？', type: 'gate' },
      { lane: 2, row: 3, text: '承認済みプラン →\nタスクを順番に実行', type: 'io' },
    ],
    s5h_tips: [
      'サイズルール: AI が 1 セッション以上かかる場合はさらに分割。各タスク: 1 入力 → 1 出力 → 1 検証コマンド',
      'タスクテンプレート: 目標 · 入力ファイル · 出力ファイル · Acceptance Criteria · 検証コマンド',
      '依存関係の順序: 各タスクの出力が次のタスクの入力になるよう順序付け。循環依存なし。',
    ],

    s6_title: 'Testing Workflow',
    s6_sub: 'Unit test · E2E Playwright · 要件ファーストテスト',
    s6_flows: [
      {
        t: 'Flow A: Unit Test',
        steps: [
          'Dev: /test [file]',
          'AI: unit-test skill をロード、functions + error paths を分析',
          'AI: TEST PLAN を生成 (コードなし — 先にレビュー)',
          'Dev: plan をレビュー ✓、シナリオを追加/削除',
          'AI: テストを作成 & 実行、失敗したら修正',
          'HOOK: coverage チェック — 閾値を下回ったらブロック',
          'Output: .test.ts ✓  Coverage ✓',
        ],
      },
      {
        t: 'Flow B: E2E Playwright',
        steps: [
          'Dev: /e2e "user checkout"',
          'AI: e2e skill をロード、ストーリー → POM ページにマッピング',
          'AI: Page Objects を作成、テストシナリオを作成',
          'AI: ヘッドレスで実行 — pass/fix ループ',
          'CI: staging へのプッシュ時に E2E スイートを実行',
          '失敗時は merge をブロック',
          'Output: .spec.ts ✓  CI report ✓',
        ],
      },
      {
        t: 'Flow C: Requirement → Tests',
        steps: [
          'BA: acceptance criteria 付きの PRD-xxx.md を作成',
          'Dev: /test-plan PRD-xxx',
          'AI: AC を抽出 → positive + negative + edge を生成',
          'Dev: test plan をレビュー ✓ (曖昧点を発見!)',
          'BA: 曖昧点を明確化',
          'AI: 失敗テスト (stubs) を作成',
          'Dev: 実装 → テストが徐々にパス → 全部グリーン ✓',
        ],
      },
    ],

    s7_title: 'Team Standardisation',
    s7_sub: 'すべての開発者が一貫した再利用可能なアウトプットを生成することを保証',
    s7_problem_t: '壊れた状態',
    s7_problem: [
      'Dev A (Cursor) → スタイル X',
      'Dev B (Claude Code) → スタイル Y',
      'Dev C (ルールなし) → スタイル Z',
      '→ レビュー時間の増加',
      '→ 増大する不整合',
      '→ 困難なオンボーディング',
    ],
    s7_solution_t: '解決策: 4 層共有標準',
    s7_solution: [
      'Layer 1 — Source of Truth: team-ai-standards/ 共有 git リポジトリ (AGENTS.md + rules/ + skills/ + templates/)',
      'Layer 2 — Gold Standard: gold-standard/examples/ (AI が学ぶ完璧な api-handler.ts, unit.test.ts)',
      'Layer 3 — Hooks + CI で強制: pre-commit gitleaks、PostToolUse 自動フォーマット、CI lint/naming/coverage ゲート',
      'Layer 4 — Skill & Docs PR プロセス: すべての変更は PR 経由、Tech Lead レビュー、マージ → チームが自動更新',
      'Output Consistency Checklist: 命名 · パターン · エラーハンドリング · コミット規約 · タスクログ · API 契約 · ADR',
    ],

    s8_title: 'Security: Credentials & Secrets',
    s8_sub: 'Defense-in-depth — 単一レイヤーに頼らない',
    s8_layers: [
      { t: 'Layer 1 — アーキテクチャ', d: 'secrets manager を使用 (AWS / Azure KV / Vault)。.env.example をコミット (実値なし)。.env.local は gitignore。' },
      { t: 'Layer 2 — Git', d: '.gitignore: .env .env.* *.pem *.key secrets/ credentials.json CLAUDE.local.md .claude/memory.json · pre-commit: gitleaks scan' },
      { t: 'Layer 3 — Permissions (settings.json)', d: 'deny: ["Read(./.env)","Read(./secrets/**)","Bash(curl *)","Bash(cat *.env)"]' },
      { t: 'Layer 4 — Hooks', d: 'security-hook.sh: .env / *.key / ~/.aws を読もうとしたら AI をブロック。Exit 2 + 通知。' },
      { t: 'Layer 5 — CI/CD Gate', d: 'gitleaks + Trufflehog をすべての PR に。シークレットパターンを検出したら merge をブロック。' },
      { t: 'Layer 6 — Rules + Training', d: 'rules/security.md: ハードコード禁止。常に process.env.X を使用。AI が sk-, api_key=, password= を自己スキャン。' },
    ],
    s8_rules_t: 'rules/security.md — AI が従うべきルール',
    s8_rules: [
      'API keys / passwords をインラインで書かないこと — process.env.VARIABLE_NAME を使用',
      '新変数は常に .env.example に追加 (実値なし)、README に記載',
      '生成したすべてのコードを自己スキャン: sk-, pk_, api_key=, password=, secret=, token=',
      'アウトプットにシークレットパターンが見つかったら → 停止、env var にリファクタ、報告',
      '.env ファイルを読まないこと — env 構造は docs/context/ のみを参照',
    ],

    s9_title: 'Input / Output Map',
    s9_sub: 'すべてのフェーズ — 誰が何をし、何が入り、何が出るか',
    s9_th: ['フェーズ', 'Human Input', 'AI が行うこと', 'Human Gate', 'Output'],
    s9_rows: [
      ['Knowledge\nFoundation', 'コードベース\n生のドキュメント\n暗黙知', '/init → パターン抽出\nCLAUDE.md ドラフト生成', 'レビュー + 承認\nコンテキスト追加', 'docs/ フォルダ\nCLAUDE.md v1'],
      ['Bootstrap', 'Tech stack\n規約\nコミュニティリポジトリ', 'skills をカスタマイズ\ncommands + hooks を作成', 'skills をレビュー\ncommands をテスト\nhooks を承認', '.claude/skills/\n.claude/commands/\nsettings.json'],
      ['Task\nIntake', 'チケット URL またはブリーフ', 'MCP でチケット読み込み\n確認質問\ntask file 作成', 'task file をレビュー\n承認', 'TASK-xxx.md\ndocs/tasks/'],
      ['Design', '承認済み task file', 'アプローチを提案\nADRs と照合\n変更ファイルをリスト', 'プランを承認\nまたは修正', 'Design notes\n更新された task file'],
      ['Implement', '/feature TASK-xxx', 'skills + rules をロード\nTDD: まずテスト\n実装 + 自己レビュー', 'diff をレビュー\n手動で AC をテスト', 'ソースコード\nUnit tests\n更新されたタスクログ'],
      ['Testing', '/test [file]\n/e2e [scenario]', 'test plan を生成\n承認を待つ\nテストを作成 & 実行', 'シナリオをレビュー\n承認', 'テストファイル\nCoverage report'],
      ['Deploy', '/deploy [env]', 'pre-deploy チェックリスト\nstaging で E2E\nSecret scan\nRelease notes', '最終承認', 'Deploy log\nE2E 結果\nRelease notes'],
      ['Improve', 'いつでも\n(バグ、パターン、新ツール)', '繰り返すパターン/エラーに\n対する更新を提案', 'レビュー + merge\n改善', '更新済み CLAUDE.md\n新規/更新された skills'],
    ],

    s10_title: 'Continuous Improvement Loop',
    s10_sub: '常時稼働 — 固定スケジュールなし、実際のイベントでトリガー',
    s10_not_t: 'これではない',
    s10_not: [
      'ドキュメントのスプリントレビューなし',
      '毎週の更新ミーティングなし',
      'ルールのスケジュールメンテナンスなし',
    ],
    s10_triggers_t: 'イベント駆動トリガー',
    s10_triggers: [
      'AI が同じミスを 2 回以上繰り返す → skill の Gotchas をすぐに更新',
      'Dev が同じ context を繰り返し説明 → CLAUDE.md または skill に追加',
      'より良いパターンを発見 → skill を更新、コミット、チームが自動取得',
      '新しいツール/モデルがリリース → 評価し、必要なら workflow を更新',
      'バグまたはセキュリティインシデント → known-issues.md に追加 / security rule を更新',
      'Tech Lead が CLAUDE.md を所有 · Senior Dev が特定 skills を所有 · 全 Dev が PR で Gotchas を報告 · AI が積極的に改善を提案',
    ],
  },
};
